import { useEffect } from 'react';

import {
  FormLabel,
  Input,
  FormHelperText,
  FormControl,
  Icon,
  Tooltip,
} from '@chakra-ui/react';

import { useAppDispatch } from 'hooks';

import SharedMessage from '../Message/SharedMessage';

import useFormBinderDisabled from 'hooks/useFormBinderDisabled';

import { SharedFormInputProps } from './FormInput.types';

const SharedFormInput = ({
  section,
  name,
  formStateKey,
  formActions,
  label,
  type,
  step,
  helpText,
  value,
  onChange,
  message,
  required,
  subLabel,
  infoText,
  disabled = false,
}: SharedFormInputProps) => {
  const dispatch = useAppDispatch();

  const htmlID = subLabel ? `${label} (${subLabel})` : label;
  const isDisabled = useFormBinderDisabled(formStateKey, disabled);

  useEffect(() => {
    if (!required) return;

    if (value.length === 0) {
      dispatch(formActions.addMissingMandatoryField({ name: htmlID, section }));
    } else {
      dispatch(formActions.removeMissingMandatoryField(htmlID));
    }
  }, [required, value, htmlID, dispatch, formActions, section]);

  return (
    <FormControl isRequired={required} isDisabled={isDisabled}>
      <FormLabel ml="0">
        {label}

        {infoText && (
          <Tooltip placement="top" label={infoText}>
            <Icon ml="5px" />
          </Tooltip>
        )}
      </FormLabel>

      <Input
        variant="main"
        value={value}
        onChange={(e) => onChange(e)}
        borderColor={!value && required ? 'red' : 'inherit'}
        type={type}
        step={step}
        id={htmlID}
        disabled={isDisabled}
        title={isDisabled ? 'Editing is disabled' : ''}
        name={name}
      />

      {helpText && <FormHelperText ml="10px">{helpText}</FormHelperText>}

      {message && (
        <SharedMessage
          {...message}
          section={section}
          formStateKey={formStateKey}
          formActions={formActions}
        />
      )}
    </FormControl>
  );
};

export default SharedFormInput;
